<ng-container *ngIf="companies !== undefined && companies.length > 1">
  <a nz-button (click)="getCompanies()" nzType="text" nz-dropdown nzTrigger="click" [nzDropdownMenu]="companiesDropdown" style="color: #fff">
    {{ userIdentity.CompanyName }}</a>
  <nz-dropdown-menu #companiesDropdown="nzDropdownMenu">
    <ul nz-menu nzSelectable>
      <ng-container *ngFor="let company of companies">
        <li *ngIf="userIdentity.CompanyDB !== company.companyDB" nz-menu-item (click)="changeCompany(company)">
          {{company.companyName}} ({{company.companyDB}})
        </li>
      </ng-container>
    </ul>
  </nz-dropdown-menu>
</ng-container>
<!-- <ng-container *ngIf="companies === undefined || companies.length === 1">
  <span>{{ userIdentity.CompanyName }}</span>
</ng-container> -->
<nz-spin *ngIf="switching" [nzTip]="'Switching' | locale" [nzSimple]="true">
</nz-spin>
